import { render, staticRenderFns } from "./RamsReject.vue?vue&type=template&id=74ebecc6&"
import script from "./RamsReject.vue?vue&type=script&lang=js&"
export * from "./RamsReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports